import axios from "axios";

// STATISTIC START
export async function requestGetStatistics(start, end) {
	return await axios.get(
		`${import.meta.env.VITE_API_URL}/admin/statistics?start=${start}&end=${end}`
	);
}
// STATISTIC END

// USER START
export async function requestGetUserList({
	page = 1,
	limit = 10,
	order = "_id:desc",
	keyword = "",
	filter = "",
}) {
	return await axios.get(
		`${
			import.meta.env.VITE_API_URL
		}/admin/users?page=${page}&limit=${limit}&keyword=${encodeURIComponent(
			keyword
		)}&filter=${filter}&order=${order}`
	);
}

export async function requestCreateUser(payload) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/admin/users/add`, payload);
}
// USER END

// SERVER START
export async function requestGetServerList({
	page = 1,
	limit = 10,
	order = "_id:desc",
	keyword = "",
	filter = "",
}) {
	return await axios.get(
		`${
			import.meta.env.VITE_API_URL
		}/admin/servers?page=${page}&limit=${limit}&keyword=${encodeURIComponent(
			keyword
		)}&filter=${filter}&order=${order}`
	);
}

export async function requestCreateServer(payload) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/admin/servers/add`, payload);
}

export async function requestGetServerById(id) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/admin/servers/${id}`);
}

export async function requestUpdateServer(id, payload) {
	return await axios.put(`${import.meta.env.VITE_API_URL}/admin/servers/${id}/edit`, payload);
}

export async function requestDeleteServer(id) {
	return await axios.delete(`${import.meta.env.VITE_API_URL}/admin/servers/${id}/delete`);
}
// WEHO END

// WEHO SERVER START
export async function requestGetWEHOServerAccountList(id) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/admin/@weho/servers/${id}/accounts`);
}

export async function requestAttachWEHOServerAccountToInstance(id, payload) {
	return await axios.post(
		`${import.meta.env.VITE_API_URL}/admin/@weho/servers/${id}/accounts/attach`,
		payload
	);
}

export async function requestDetachWEHOServerAccountFromInstance(id, accountId) {
	return await axios.delete(
		`${import.meta.env.VITE_API_URL}/admin/@weho/servers/${id}/accounts/${accountId}/detach`
	);
}
// WEHO SERVER END

// WEHO SERVER ACCOUNT START
export async function requestShowWEHOAccountDetails(id) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/admin/@weho/accounts/${id}`);
}
// WEHO SERVER ACCOUNT END

// APLA SERVER START
export async function requestGetAPLAServerApplicationList(id) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/admin/@apla/servers/${id}/applications`);
}

export async function requestAttachAPLAServerApplicationToInstance(id, payload) {
	return await axios.post(
		`${import.meta.env.VITE_API_URL}/admin/@apla/servers/${id}/applications/attach`,
		payload
	);
}

export async function requestGetAPLAServerDatabaseList(id) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/admin/@apla/servers/${id}/databases`);
}

export async function requestAttachAPLAServerDatabaseToInstance(id, payload) {
	return await axios.post(
		`${import.meta.env.VITE_API_URL}/admin/@apla/servers/${id}/databases/attach`,
		payload
	);
}

export async function requestGetAPLAServerServiceList(id) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/admin/@apla/servers/${id}/services`);
}

export async function requestAttachAPLAServerServiceToInstance(id, payload) {
	return await axios.post(
		`${import.meta.env.VITE_API_URL}/admin/@apla/servers/${id}/services/attach`,
		payload
	);
}
// APLA SERVER END

// APLA APPLICATION START
export async function requestGetAPLAApplicationLogs(id) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/admin/@apla/applications/${id}/logs`);
}
// APLA APPLICATION END

// CUSTOMER START
export async function requestGetCustomerList({
	page = 1,
	limit = 10,
	order = "_id:desc",
	keyword = "",
	filter = "",
}) {
	return await axios.get(
		`${
			import.meta.env.VITE_API_URL
		}/admin/users?page=${page}&limit=${limit}&keyword=${encodeURIComponent(
			keyword
		)}&filter=${filter}&order=${order}`
	);
}

export async function requestCreateCustomer(payload) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/admin/users/add`, payload);
}

export async function requestGetCustomerById(id) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/admin/users/${id}`);
}

export async function requestUpdateCustomer(id, payload) {
	return await axios.put(`${import.meta.env.VITE_API_URL}/admin/users/${id}/edit`, payload);
}

export async function requestDeleteCustomer(id) {
	return await axios.delete(`${import.meta.env.VITE_API_URL}/admin/users/${id}/delete`);
}

export async function requestAddCustomerAddress(customerId, addressData) {
	return await axios.post(
		`${import.meta.env.VITE_API_URL}/admin/users/${customerId}/addresses/add`,
		addressData
	);
}

export async function requestUpdateCustomerAddress(customerId, addressId, addressData) {
	return await axios.put(
		`${import.meta.env.VITE_API_URL}/admin/users/${customerId}/addresses/${addressId}/edit`,
		addressData
	);
}

export async function requestDeleteCustomerAddress(customerId, addressId) {
	return await axios.delete(
		`${import.meta.env.VITE_API_URL}/admin/users/${customerId}/addresses/${addressId}/delete`
	);
}
// CUSTOMER END

// SERVICE START
export async function requestGetServiceList({
	page = 1,
	limit = 10,
	order = "_id:desc",
	keyword = "",
	filter = "",
}) {
	return await axios.get(
		`${
			import.meta.env.VITE_API_URL
		}/admin/services?page=${page}&limit=${limit}&keyword=${encodeURIComponent(
			keyword
		)}&filter=${filter}&order=${order}`
	);
}

export async function requestCreateService(payload) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/admin/services/add`, payload);
}

export async function requestGetServiceById(id) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/admin/services/${id}`);
}

export async function requestUpdateService(id, payload) {
	return await axios.put(`${import.meta.env.VITE_API_URL}/admin/services/${id}/edit`, payload);
}

export async function requestDeleteService(id) {
	return await axios.delete(`${import.meta.env.VITE_API_URL}/admin/services/${id}/delete`);
}
// SERVICE END

// SERVICE GROUP START
export async function requestGetServiceGroupList({
	page = 1,
	limit = 10,
	order = "_id:desc",
	keyword = "",
	filter = "",
}) {
	return await axios.get(
		`${
			import.meta.env.VITE_API_URL
		}/admin/service-groups?page=${page}&limit=${limit}&keyword=${encodeURIComponent(
			keyword
		)}&filter=${filter}&order=${order}`
	);
}

export async function requestCreateServiceGroup(payload) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/admin/service-groups/add`, payload);
}

export async function requestGetServiceGroupById(id) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/admin/service-groups/${id}`);
}

export async function requestUpdateServiceGroup(id, payload) {
	return await axios.put(
		`${import.meta.env.VITE_API_URL}/admin/service-groups/${id}/edit`,
		payload
	);
}

export async function requestDeleteServiceGroup(id) {
	return await axios.delete(`${import.meta.env.VITE_API_URL}/admin/service-groups/${id}/delete`);
}
// SERVICE GROUP END

// ORDER MANAGEMENT START
export async function requestGetOrderList({
	page = 1,
	limit = 10,
	order = "issuedAt:desc",
	keyword = "",
	filter = "",
}) {
	const apiUrl = import.meta.env.VITE_API_URL || "http://localhost:3000";
	const encodedKeyword = encodeURIComponent(keyword);

	return await axios.get(
		`${apiUrl}/admin/orders?page=${page}&limit=${limit}&keyword=${encodedKeyword}&filter=${filter}&order=${order}`
	);
}

export async function requestGetOrderById(orderId) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/admin/orders/${orderId}`);
}

export async function requestCreateOrder(payload) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/admin/orders/create`, payload);
}

export async function requestUpdateOrderStatus(orderId, payload) {
	return await axios.put(
		`${import.meta.env.VITE_API_URL}/admin/orders/${orderId}/update-status`,
		payload
	);
}

export async function requestGetOrderStatistics(params) {
	const queryParams = new URLSearchParams(params).toString();
	return await axios.get(`${import.meta.env.VITE_API_URL}/admin/orders/statistics?${queryParams}`);
}
// ORDER MANAGEMENT END

// INVOICE MANAGEMENT START
export async function requestGetInvoiceList({
	page = 1,
	limit = 10,
	order = "issuedAt:desc",
	keyword = "",
	filter = "",
}) {
	const apiUrl = import.meta.env.VITE_API_URL || "http://localhost:3000";
	const encodedKeyword = encodeURIComponent(keyword);
	return await axios.get(
		`${apiUrl}/admin/invoices?page=${page}&limit=${limit}&keyword=${encodedKeyword}&filter=${filter}&order=${order}`
	);
}

export async function requestGetInvoiceById(invoiceId) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/admin/invoices/${invoiceId}`);
}

export async function requestCreateInvoiceFromOrder(payload) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/admin/invoices/create`, payload);
}

export async function requestMarkInvoiceAsPaid(invoiceId, payload) {
	return await axios.put(
		`${import.meta.env.VITE_API_URL}/admin/invoices/${invoiceId}/mark-paid`,
		payload
	);
}

export async function requestShareInvoiceToPublic(invoiceId) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/admin/invoices/${invoiceId}/share`);
}
// INVOICE MANAGEMENT END

// TRANSACTION MANAGEMENT START
export async function requestGetTransactionList({
	page = 1,
	limit = 10,
	order = "_id:desc",
	keyword = "",
	filter = "",
}) {
	return await axios.get(
		`${
			import.meta.env.VITE_API_URL
		}/admin/transactions?page=${page}&limit=${limit}&keyword=${keyword}&filter=${filter}&order=${order}`
	);
}

export async function requestGetInvoiceTransactionList(invoiceId) {
	return await axios.get(
		`${import.meta.env.VITE_API_URL}/admin/transactions?filter=invoice:${invoiceId}`
	);
}

export async function requestGetTransactionById(id) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/admin/transactions/${id}`);
}

export async function requestProcessPayment(id, payload) {
	return await axios.put(
		`${import.meta.env.VITE_API_URL}/admin/transactions/${id}/process-payment`,
		payload
	);
}

export async function requestCreateTransaction(payload) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/admin/transactions/create`, payload);
}

export async function requestCreateRefund(payload) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/admin/transactions/refund`, payload);
}
// TRANSACTION MANAGEMENT END

// INSTANCE MANAGEMENT START
export async function requestGetInstanceList({
	page = 1,
	limit = 10,
	order = "expiredAt:asc",
	keyword = "",
	filter = "",
}) {
	return await axios.get(
		`${
			import.meta.env.VITE_API_URL
		}/admin/instances?page=${page}&limit=${limit}&order=${order}&keyword=${keyword}&filter=${filter}`
	);
}

export async function requestShowInstance(instanceId) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/admin/instances/${instanceId}`);
}

export async function requestUpdateInstanceBillingInformation(instanceId, payload) {
	return await axios.put(
		`${import.meta.env.VITE_API_URL}/admin/instances/${instanceId}/update-billing`,
		payload
	);
}

export async function requestUpdateInstanceMetadata(instanceId, metadata) {
	return await axios.put(
		`${import.meta.env.VITE_API_URL}/admin/instances/${instanceId}/update-metadata`,
		{
			metadata: metadata,
		}
	);
}

export async function requestProvisionInstancesFromInvoice(payload) {
	return await axios.post(
		`${import.meta.env.VITE_API_URL}/admin/instances/provision-from-invoice`,
		payload
	);
}

export async function requestSuspendInstance(instanceId, payload) {
	return await axios.put(
		`${import.meta.env.VITE_API_URL}/admin/instances/${instanceId}/suspend`,
		payload
	);
}

export async function requestTerminateInstance(instanceId, payload) {
	return await axios.put(
		`${import.meta.env.VITE_API_URL}/admin/instances/${instanceId}/terminate`,
		payload
	);
}

export async function requestUpdateInstanceStatus(instanceId, payload) {
	return await axios.put(
		`${import.meta.env.VITE_API_URL}/admin/instances/${instanceId}/update-status`,
		payload
	);
}

export async function requestStartInstanceProvisioning(instanceId) {
	return await axios.put(
		`${import.meta.env.VITE_API_URL}/admin/instances/${instanceId}/start-provisioning`
	);
}
// INSTANCE MANAGEMENT END

// WORKFLOW MANAGEMENT START
export async function requestCreateOrderWorkflow(payload) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/admin/workflows/create-order`, payload);
}

export async function requestCompleteOrderToProvisioningWorkflow(payload) {
	return await axios.post(
		`${import.meta.env.VITE_API_URL}/admin/workflows/complete-order-to-provisioning`,
		payload
	);
}

export async function requestBulkTerminationWorkflow(payload) {
	return await axios.post(
		`${import.meta.env.VITE_API_URL}/admin/workflows/bulk-termination`,
		payload
	);
}

export async function requestGetWorkflowStatus(orderId, teamId) {
	return await axios.get(
		`${import.meta.env.VITE_API_URL}/admin/workflows/status/${orderId}?teamId=${teamId}`
	);
}
// WORKFLOW MANAGEMENT END

// USER MANAGEMENT START
export async function requestGetUserDetail(id) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/admin/users/${id}`);
}

export async function requestUpdateUser(id, payload) {
	return await axios.put(`${import.meta.env.VITE_API_URL}/admin/users/${id}`, payload);
}

export async function requestDeleteUser(id) {
	return await axios.delete(`${import.meta.env.VITE_API_URL}/admin/users/${id}`);
}
// USER MANAGEMENT END

// TEAM MANAGEMENT START
export async function requestGetTeamList({
	page = 1,
	limit = 10,
	order = "_id:desc",
	keyword = "",
	filter = "",
}) {
	return await axios.get(
		`${
			import.meta.env.VITE_API_URL
		}/admin/teams?page=${page}&limit=${limit}&keyword=${encodeURIComponent(
			keyword
		)}&filter=${filter}&order=${order}`
	);
}

export async function requestCreateTeam(payload) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/admin/teams/add`, payload);
}

export async function requestGetTeamById(id) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/admin/teams/${id}`);
}

export async function requestUpdateTeam(id, payload) {
	return await axios.put(`${import.meta.env.VITE_API_URL}/admin/teams/${id}/edit`, payload);
}

export async function requestDeleteTeam(id) {
	return await axios.delete(`${import.meta.env.VITE_API_URL}/admin/teams/${id}/delete`);
}

export async function requestAddTeamMember(teamId, payload) {
	return await axios.post(
		`${import.meta.env.VITE_API_URL}/admin/teams/${teamId}/members/add`,
		payload
	);
}

export async function requestRemoveTeamMember(teamId, memberId) {
	return await axios.delete(
		`${import.meta.env.VITE_API_URL}/admin/teams/${teamId}/members/${memberId}/remove`
	);
}
// TEAM MANAGEMENT END

// DOMAIN EXTENSIONS START
export async function requestGetDomainExtensionList({
	page = 1,
	limit = 10,
	order = "_id:desc",
	keyword = "",
	filter = "",
}) {
	const params = new URLSearchParams({
		page: page.toString(),
		limit: limit.toString(),
		keyword: encodeURIComponent(keyword),
		filter,
		order,
	});

	return await axios.get(`${import.meta.env.VITE_API_URL}/admin/domain-extensions?${params}`);
}

export async function requestCreateDomainExtension(payload) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/admin/domain-extensions/add`, payload);
}

export async function requestGetDomainExtensionById(id) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/admin/domain-extensions/${id}`);
}

export async function requestUpdateDomainExtension(id, payload) {
	return await axios.put(
		`${import.meta.env.VITE_API_URL}/admin/domain-extensions/${id}/edit`,
		payload
	);
}

export async function requestDeleteDomainExtension(id) {
	return await axios.delete(`${import.meta.env.VITE_API_URL}/admin/domain-extensions/${id}/delete`);
}
// DOMAIN EXTENSIONS END

// DOMAIN START
export async function requestGetDomainList({
	page = 1,
	limit = 10,
	order = "expiredAt:asc",
	keyword = "",
	filter = "",
}) {
	const params = new URLSearchParams({
		page: page.toString(),
		limit: limit.toString(),
		keyword: encodeURIComponent(keyword),
		filter,
		order,
	});

	return await axios.get(`${import.meta.env.VITE_API_URL}/admin/domains?${params}`);
}

export async function requestGetDomainById(id) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/admin/domains/${id}`);
}

export async function requestEditDomain(id, payload) {
	return await axios.put(`${import.meta.env.VITE_API_URL}/admin/domains/${id}/edit`, payload);
}

export async function requestUpdateDomainBillingInformation(id, payload) {
	return await axios.put(
		`${import.meta.env.VITE_API_URL}/admin/domains/${id}/update-billing`,
		payload
	);
}

export async function requestStartDomainRegistration(id) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/admin/domains/${id}/start-registration`);
}

export async function requestRegisterDomainsFromInvoice(payload) {
	return await axios.post(
		`${import.meta.env.VITE_API_URL}/admin/domains/register-from-invoice`,
		payload
	);
}
// DOMAIN END

// CRON LOG START
export async function requestGetCronLogList({
	page = 1,
	limit = 10,
	order = "_id:desc",
	keyword = "",
	filter = "",
}) {
	return await axios.get(
		`${
			import.meta.env.VITE_API_URL
		}/admin/cron-logs?page=${page}&limit=${limit}&keyword=${encodeURIComponent(
			keyword
		)}&filter=${filter}&order=${order}`
	);
}

export async function requestGetCronLogById(id) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/admin/cron-logs/${id}`);
}
// CRON LOG END
